import {createContext, use} from 'react'

import type Artwork from '../../webgl/Artwork'
import type {BrandedDividerRegistration, DitherRegistration, EnterpriseHeroRegistration} from './WebGLContext.types'

export type {
  BrandedDividerParams,
  BrandedDividerRegistration,
  DitherParams,
  DitherRegistration,
  EnterpriseHeroRegistration,
} from './WebGLContext.types'

export type WebGLType = Artwork | null
export type WebGLStatus = 'loading' | 'available' | 'unavailable'

type WebGLContextType = {
  registerDither: (registration: DitherRegistration) => void
  unregisterDither: (id: string) => void
  registerBrandedDivider: (registration: BrandedDividerRegistration) => void
  unregisterBrandedDivider: (id: string) => void
  registerEnterpriseHero: (registration: EnterpriseHeroRegistration) => void
  unregisterEnterpriseHero: (id: string) => void
}

export const WebGLContext = createContext<WebGLContextType | null>(null)
export const WebGLArtworkContext = createContext<Artwork | null>(null)
export const WebGLStatusContext = createContext<WebGLStatus>('loading')

export const useWebGLStatus = () => use(WebGLStatusContext)

export const useWebGLContext = () => {
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  const context = use(WebGLContext)!
  const artwork = use(WebGLArtworkContext)

  return {...context, artwork}
}
